import { ComponentProps, ReactNode } from 'react';
import clsx from 'clsx';

import styles from './PersonCard.module.css';

interface PersonCardProps extends Omit<ComponentProps<'article'>, 'title'> {
  image: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  cta?: ReactNode;
}

export default function PersonCard({ image, title, subtitle, cta, className, ...props }: PersonCardProps) {
  return (
    <article
      className={clsx(styles.card, className)}
      itemScope
      itemType="https://schema.org/Person"
      {...props}
    >
      <div className={styles.head}>
        <div
          className={styles.avatar}
          itemProp="image"
        >
          {image}
        </div>
        <div className={styles.text}>
          <div
            className={styles.name}
            itemProp="name"
          >
            {title}
          </div>
          {subtitle ? (
            <div
              className={styles.detail}
              itemProp="roleName"
            >
              {subtitle}
            </div>
          ) : null}
        </div>
      </div>
      {cta ? (
        <div
          className={styles.cta}
          itemProp="url"
        >
          {cta}
        </div>
      ) : null}
    </article>
  );
}
